import React from 'react'
import { FormattedMessage } from 'react-intl'
import CheckPercent from '../../public/images/icons/checkPercent.svg'
import { useStyleProductResume } from '@/components/Product/ProductResume'
import { formatDateTimeStamp } from '@/lib/formatDate'
import clsx from 'clsx'

type Props = {
  style?: any
  promotionLimited?: any
  className?: string
}

const PromotionPastille: React.FC<Props> = ({ promotionLimited, style = {}, className }) => {
  const classesResume = useStyleProductResume({})

  return (
    <div className={clsx(classesResume.rootInfoProduct, className)} style={style}>
      <div className={classesResume.svgInfoProduct}>
        <CheckPercent width={21} height={21} />
      </div>
      <div className={classesResume.infoProduct}>
        <FormattedMessage id={'web_promotions'} />
        {promotionLimited?.to_date && ` jusqu'au ${formatDateTimeStamp(promotionLimited?.to_date)}`}
      </div>
    </div>
  )
}

export default PromotionPastille
